<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("edit") }} {{ $tc("Movie", 1) }} {{ $tc("Experience", 1) }}
      </div>
      <div>
        <router-link class="btn-blue" to="movie-experiences"
          >{{ $tc("Movie", 1) }} {{ $tc("Experience", 1) }}
          {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-3 align-self-center mb-0">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="movie_experience_name"
                name="movie_experience_name"
                v-validate="'required'"
                @input="onChangeInput($event, 'movie_experience_name')"
                v-model="movie_experience.movie_experience_name"
                placeholder="."
                maxlength="100"
              />
              <label
                :class="
                  movie_experience.movie_experience_name ? 'shift-up' : ''
                "
                >{{ "Movie Experience Name" }}
              </label>
            </div>
          </div>
          <p class="error_message" style="margin-top: 2px">
            <span v-if="submitted && errors.has('movie_experience_name')">{{
              errors.first("movie_experience_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="row align-self-center">
            <div class="col-10">
              <label
                class="material-file-upload"
                @click.prevent.stop="
                  setModalData(banner_image_height, banner_image_width)
                "
              >
                <div class="label"></div>
                <div class="uploaded-file-name">
                  <div class="text-truncate">
                    {{
                      movie_experience.movie_experience_image_url
                        ? movie_experience.movie_experience_image_url
                        : "Movie Experience Image"
                    }}
                  </div>
                </div>
              </label>
            </div>
            <div class="col-1 mt-1">
              <img
                width="40"
                height="40"
                class="rounded c-pointer img-preview"
                @click="
                  openImageModal(
                    '',
                    movie_experience.movie_experience_image_url
                  )
                "
                :src="
                  _GetImagePath(movie_experience.movie_experience_image_url)
                "
                v-if="movie_experience.movie_experience_image_url"
              />
              <img
                v-else
                width="35"
                height="35"
                class="rounded"
                alt="Empty Image"
                src="@/assets/img/icons/empty-image.svg"
              />
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-3">
          <div class="row align-self-center">
            <div class="col-10">
              <label
                class="material-file-upload"
                @click.prevent.stop="
                  setModalDataBanner(
                    page_banner_image_height,
                    page_banner_image_width
                  )
                "
              >
                <div class="label"></div>
                <div class="uploaded-file-name">
                  <div class="text-truncate">
                    {{
                      movie_experience.movie_experience_image_banner_url
                        ? movie_experience.movie_experience_image_banner_url
                        : "Movie Experience Image Banner"
                    }}
                  </div>
                </div>
              </label>
            </div>
            <div class="col-1 mt-1">
              <img
                width="40"
                height="40"
                class="rounded c-pointer img-preview"
                @click="
                  openImageModal(
                    '',
                    movie_experience.movie_experience_image_banner_url
                  )
                "
                :src="
                  _GetImagePath(
                    movie_experience.movie_experience_image_banner_url
                  )
                "
                v-if="movie_experience.movie_experience_image_banner_url"
              />
              <img
                v-else
                width="35"
                height="35"
                class="rounded"
                alt="Empty Image"
                src="@/assets/img/icons/empty-image.svg"
              />
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-0">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="movie_experience_link"
                name="movie_experience_link"
                @input="onChangeInput($event, 'movie_experience_link')"
                v-model="movie_experience.movie_experience_link"
                placeholder="."
                maxlength="100"
              />
              <label
                :class="
                  movie_experience.movie_experience_link ? 'shift-up' : ''
                "
                >{{ "Youtube Link" }}
              </label>
            </div>
          </div>
          <p class="error_message" style="margin-top: 2px">
            <span v-if="submitted && errors.has('movie_experience_link')">{{
              errors.first("movie_experience_link")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 mt-1">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>
            <b-form-checkbox
              unchecked-value="N"
              v-model="movie_experience.movie_experience_is_active"
              value="Y"
              name="check-button"
              switch
              class="j-checkbox"
            ></b-form-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <section class="my-3 w-100 px-3 distributor-section-new">
          <div
            class="section-title d-flex justify-content-between section-border section-border"
            v-b-toggle.transalations
            style="padding: 6px; align-items: center"
          >
            <span class="fs">
              {{ "Translations" }}
            </span>
            <button type="button" class="btn-transparent chevron">
              <img
                src="@/assets/img/icons/primary/chevron-down.svg"
                height="24"
                width="24"
              />
            </button>
          </div>
          <b-collapse
            id="transalations"
            class="mt-2 translationContainer"
            v-model="sectionCollapse.transalations"
          >
            <div class="bn-tabs-nav">
              <button
                v-for="(content, contentIndex) in langContent"
                :key="contentIndex"
                :class="[
                  'btn-tab-title ',
                  { active: contentIndex == activeClass },
                ]"
                @click.prevent.stop="onChangeTabHandler($event, contentIndex)"
              >
                <strong>
                  <span :class="notempty[contentIndex] ? '' : 'text-danger'">{{
                    content.langauge
                  }}</span>
                </strong>
              </button>
              <span class="editBtn" v-if="langContent.length > 0">
                <button
                  class="btn btn-sm btn-primary"
                  @click="
                    isEdit = !isEdit;
                    isEditHtml = false;
                  "
                >
                  <img
                    v-if="!isEdit"
                    src="@/assets/img/icons/edit-pen-white.svg"
                    height="15"
                    width="15"
                    class="mr-1"
                  />{{ isEdit ? "Save Text" : "Edit Text" }}
                </button>
                <button
                  class="btn btn-sm btn-primary"
                  @click="
                    isEditHtml = !isEditHtml;
                    isEdit = false;
                  "
                >
                  <img
                    v-if="!isEditHtml"
                    src="@/assets/img/icons/edit-pen-white.svg"
                    height="15"
                    width="15"
                    class="mr-1"
                  />{{ isEditHtml ? "Save HTML" : "Edit HTML" }}
                </button>
              </span>
            </div>

            <div class="bn-tabs-content p-3">
              <div
                v-for="(content, contentIndex) in langContent"
                :key="contentIndex"
              >
                <div v-if="contentIndex === activeClass">
                  <div class="row pt-4">
                    <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            id="movie_experience_name"
                            name="movie_experience_name"
                            v-validate="'required'"
                            @input="
                              onChangeTranslationInput(
                                $event,
                                content,
                                contentIndex,
                                'movie_experience_name'
                              )
                            "
                            v-model="content.movie_experience_name"
                            placeholder="."
                            maxlength="100"
                          />
                          <label
                            :class="
                              content.movie_experience_name ? 'shift-up' : ''
                            "
                            >{{ "Movie Experience Name" }}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                      <div class="row align-self-center">
                        <div class="col-10">
                          <label
                            class="material-file-upload"
                            @click.prevent.stop="
                              setModalData(
                                banner_image_height,
                                banner_image_width,
                                contentIndex
                              )
                            "
                          >
                            <div class="label"></div>
                            <div class="uploaded-file-name">
                              <div class="text-truncate">
                                {{
                                  content.movie_experience_image_url
                                    ? content.movie_experience_image_url
                                    : "Movie Experience Image"
                                }}
                              </div>
                            </div>
                          </label>
                        </div>
                        <div class="col-1 mt-1">
                          <img
                            width="40"
                            height="40"
                            class="rounded c-pointer img-preview"
                            @click="
                              openImageModal(
                                '',
                                content.movie_experience_image_url
                              )
                            "
                            :src="
                              _GetImagePath(content.movie_experience_image_url)
                            "
                            v-if="content.movie_experience_image_url"
                          />
                          <img
                            v-else
                            width="35"
                            height="35"
                            class="rounded"
                            alt="Empty Image"
                            src="@/assets/img/icons/empty-image.svg"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            id="movie_experience_link"
                            name="movie_experience_link"
                            @input="
                              onChangeTranslationInput(
                                $event,
                                content,
                                contentIndex,
                                'movie_experience_link'
                              )
                            "
                            v-model="content.movie_experience_link"
                            placeholder="."
                            maxlength="100"
                          />
                          <label
                            :class="
                              content.movie_experience_link ? 'shift-up' : ''
                            "
                            >{{ "Youtube Link" }}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 align-self-center mb-4">
                      <div
                        class="descriptionSection font-weight-bold fs-14 mb-3"
                      >
                        Description
                      </div>
                      <div class="" v-if="isEdit">
                        <vue-editor
                          v-model="content.movie_experience_description"
                          name="page"
                          id="page"
                        ></vue-editor>
                      </div>
                      <div
                        class="input-material-textarea"
                        v-else-if="isEditHtml && !isEdit"
                      >
                        <textarea
                          id="htmlContent"
                          name="htmlContent"
                          @input="
                            onChangeTranslationInput(
                              $event,
                              content,
                              contentIndex,
                              'movie_experience_description'
                            )
                          "
                          v-model="content.movie_experience_description"
                          placeholder="Page Content"
                          class="htmlContent"
                        />
                      </div>
                      <div class="ql-snow" v-else>
                        <div
                          class="ql-editor"
                          v-html="content.movie_experience_description"
                          v-if="content.movie_experience_description"
                        ></div>
                        <div
                          class="ql-editor text-center"
                          v-else
                          style="min-height: 33px"
                        >
                          No Content
                        </div>
                      </div>
                      <vue-editor style="display: none" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </section>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onUpdateHandler"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="resetHandler"
            class="btn-black"
          >
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="movie-experiences"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ tempModalImageName }}</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <br />
      <img :src="tempModalImagePath" class="img-fluid" />
    </b-modal>

    <ImageGallery
      v-bind:propImageName="'Movie Banner'"
      v-bind:openModal="showModal"
      v-bind:set_height="set_height"
      v-bind:set_width="set_width"
      :showPercentageLoader="true"
      :img_desc="'Movie Banner'"
      :resetImgData="false"
      :category="'Movie Banner'"
    ></ImageGallery>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import MovieService from "@/services/MovieService";
  import MovieExperience from "@/helper/formJSONMaster/MovieExperience";
  import ImageGallery from "../../ImageGallery/imageGalleryModal";
  import { mapGetters } from "vuex";
  import { VueEditor } from "vue2-editor";
  import _ from "lodash";
  export default {
    components: { ImageGallery, VueEditor },
    data() {
      return {
        sectionCollapse: {
          transalations: true,
        },
        editCode: false,
        isEdit: true,
        isEditHtml: false,
        btenable: false,
        langContent: [],
        Languages: [],
        ContentLanguages: [],
        activeClass: 0,
        notempty: [false, false, false, false, false, false],
        movie_experience: {
          movie_experience_id: null,
          movie_experience_name: "",
          movie_experience_description: "",
          movie_experience_image_url: "",
          movie_experience_image_banner_url: "",
          movie_experience_link: "",
          movie_experience_is_active: "Y",
        },

        btenable: false,
        Methods: MovieExperience.Methods,
        MovieExperience: MovieExperience.ms_movie_experiences,
        submitted: false,
        imageBannerIndex: null,
        set_height: null,
        set_width: null,
        showModal: null,
        imgUrl: null,
        imagePath: null,
        filePath: null,
        filename: null,
        banner_image_height: 2,
        banner_image_width: 2,
        page_banner_image_height: 499,
        page_banner_image_width: 1520,
        tempModalImageName: null,
        tempModalImagePath: null,
        bannerUpload: false,
      };
    },
    // computed: {
    //   ...mapGetters(["finalImagePath"])
    // },
    // watch: {
    //   finalImagePath(newVal) {
    //     this.filePath = newVal;
    //   }
    // },
    beforeMount() {
      const { id } = this.$route.query;
      console.log("id :", id);
      if (id) {
        this.getEditList(id);
      } else {
        this.$router.go(-1);
      }
    },
    computed: {
      ...mapGetters(["finalImagePath"]),
    },
    watch: {
      finalImagePath(newVal) {
        console.log("newVal :>> ", newVal);
        this.filePath = newVal;
        if (!isNaN(String(this.uploadIndex))) {
          this.langContent[
            this.uploadIndex
          ].movie_experience_image_url = newVal;
          if (
            this.langContent[this.uploadIndex].langauge.toLowerCase() ==
            "english"
          ) {
            this.movie_experience.movie_experience_image_url = newVal;
          }
        } else if (this.bannerUpload) {
          this.movie_experience.movie_experience_image_banner_url = newVal;
        } else {
          let index =
            this.langContent.findIndex(
              (x) => x.langauge.toLowerCase() == "english"
            ) || 0;
          this.langContent[index]["movie_experience_image_url"] = newVal;
          this.movie_experience.movie_experience_image_url = newVal;
        }
      },
    },
    mounted() {},
    methods: {
      CheckEmptyContent: function(content, langIndex) {
        if (
          content.movie_experience_name ||
          content.movie_experience_description ||
          content.movie_experience_link
        ) {
          this.notempty[langIndex] = true;
        } else {
          this.notempty[langIndex] = false;
        }
      },
      onChangeInput(event, item) {
        let index =
          this.langContent.findIndex(
            (x) => x.langauge.toLowerCase() == "english"
          ) || 0;
        this.langContent[index][item] = event.target.value;
      },
      onChangeTranslationInput(event, content, contentIndex, item) {
        if (content.langauge.toLowerCase() == "english") {
          this.movie_experience[item] = event.target.value;
        }
        this.CheckEmptyContent(content, contentIndex);
      },
      onChangeTabHandler: function(event, index) {
        this.activeClass = index;
      },
      getContentLanguage: function(ContentData) {
        MovieService.GetMovieContentLanguages()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.ContentLanguages.length > 0) {
                this.ContentLanguages = data.ContentLanguages;
              }
              console.log("this.ContentLanguages", this.ContentLanguages);
            } else {
              // Show Error:
              console.log("data.message :", data.message);
            }
            return;
          })
          .then(() => {
            this.makeLangContainers(ContentData);
          })
          .catch((error) => {});
      },
      makeLangContainers: function(Content) {
        console.log("Content", Content);
        console.log("this.ContentLanguages", this.ContentLanguages);
        this.ContentLanguages.map((x, i) => {
          let Array1 = [];
          if (Content && Content.length > 0) {
            Array1 = Content.filter((y) => {
              return y.langaugeId == x.langaugeId;
            });
          }

          console.log("Array1", Array1);
          if (Array1.length > 0) {
            x["movie_experience_name"] = Array1[0].movie_experience_name;
            x["movie_experience_description"] = _.unescape(
              Array1[0].movie_experience_description
            );
            x["movie_experience_image_url"] =
              Array1[0].movie_experience_image_url;
            x["movie_experience_link"] = Array1[0].movie_experience_link;
            if (
              Array1[0].movie_experience_name ||
              Array1[0].movie_experience_description ||
              Array1[0].movie_experience_image_url ||
              Array1[0].movie_experience_link
            ) {
              this.notempty[i] = true;
            }
          } else {
            x["movie_experience_name"] = "";
            x["movie_experience_description"] = "";
            x["movie_experience_image_url"] = "";
            x["movie_experience_link"] = "";
          }
        });
        this.langContent = this.ContentLanguages;
        console.log("this.langContent", this.langContent);
      },
      onFocusHandler: function() {
        // this.submitted = false;
      },
      resetHandler: function() {
        this.MovieExperience.map((x) => {
          if (x.type === "text" || x.type === "date") {
            x.fieldvalue = "";
          } else if (x.type === "radio") {
            x.fieldvalue = true;
          }
        });
        this.imgUrl = null;
        this.imagePath = null;
      },
      setModalData(height, width, contentIndex = null) {
        // this.imageBannerIndex = index;
        this.set_height = height;
        this.set_width = width;
        this.uploadIndex = contentIndex;
        this.showModal = !this.showModal;
      },
      setModalDataBanner(height, width, contentIndex = null) {
        this.bannerUpload = true;
        this.$forceUpdate();
        this.set_height = height;
        this.set_width = width;
        this.showModal = !this.showModal;
      },
      openImageModal: function(image_name, image_path) {
        this.tempModalImagePath = image_path;
        this.tempModalImageName = image_name;
        this.$refs["preview-modal"].show();
      },

      getEditList: function(id) {
        let ContentData = [];
        MasterService.GetMovieExperienceFormat(id)
          .then((response) => {
            console.log("fromresponse", response);
            const { data } = response;
            if (data.status) {
              console.log("data :", data);
              let obj = data.Records[0];

              this.imgUrl = obj.img_url;
              this.imagePath = obj.image_path;
              this.movie_experience["movie_experience_name"] =
                obj.movie_experience;
              this.movie_experience["movie_experience_id"] =
                obj.movie_experience_id;
              this.movie_experience["movie_experience_image_url"] =
                obj.image_path;
              this.movie_experience["movie_experience_image_banner_url"] =
                obj.movie_experience_image_banner_url;
              this.movie_experience["movie_experience_link"] =
                obj.movie_experience_link;

              ContentData = JSON.parse(obj.translation_data);

              this.MovieExperience.map((x) => {
                if (x.fieldname === "movie_experience_is_active") {
                  x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
                } else if (x.type === "date") {
                  x.fieldvalue = this.formatDate(obj[x.fieldname]);
                } else {
                  x.fieldvalue = obj[x.fieldname];
                  console.log(this.MovieExperience);
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(data.error);
          })
          .finally(() => {
            this.getContentLanguage(ContentData);
          });
      },
      onUpdateHandler: function() {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          console.log("valid :", valid);
          if (valid) {
            this.btenable = true;
            this.movie_experience[
              "movie_experience_description"
            ] = this.langContent[0].movie_experience_description;
            let payload = {
              ...this.movie_experience,
              transalation_data: this.langContent,
            };
            MasterService.UpdateMovieExperienceFormat(payload)
              .then((response) => {
                this.btenable = false;
                const { data } = response;

                if (data.status) {
                  console.log("here :", data);
                  this.$toasted.show("Movie Experience Updated");
                  this.$router.push({
                    path: "movie-experiences",
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((error) => {
                this.$toasted.show(error);
              });
          } else {
            console.log("else :");
          }
        });
      },
    },
  };
</script>
<style>
  .editBtn {
    position: absolute;
    right: 0;
  }

  .htmlContent {
    min-height: 250px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/MovieExperienceComponent/EditMovieExperience.vue